export const FETCH_ALL_CLIENTS = "FETCH_ALL_CLIENTS";
export const CLEAR_ALL_FILTERS = "CLEAR_ALL_FILTERS";
export const ROWS_COUNT_AFTER_FILTER = "ROWS_COUNT_AFTER_FILTER";
export const IS_EDITED = "IS_EDITED";
export const SAVE_EDITS = "SAVE_EDITS";
export const SHOW_LOADER = "SHOW_LOADER"; 
export const DISCARD_CHANGES_CLIENT = "DISCARD_CHANGES_CLIENT";
export const GET_SELECTED_CLIENTS = "GET_SELECTED_CLIENTS";
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT";
export const FETCH_CLIENT_TYPES = "FETCH_CLIENT_TYPES";
export const FETCH_GENERATION_TYPES = "FETCH_GENERATION_TYPES";
export const FETCH_LOCATIONS = "FETCH_LOCATIONS";
export const FETCH_TASK_TYPES = "FETCH_TASK_TYPES";
export const FETCH_GROUPS = "FETCH_GROUPS";
export const GET_CLIENTS_BY_ID = "GET_CLIENTS_BY_ID";
export const GET_FIRM_SETTINGS = "GET_FIRM_SETTINGS";
export const GET_SAVED_CLIENTS_DATA = "GET_SAVED_CLIENTS_DATA";
export const UNLINK_CLIENTS = "UNLINK_CLIENTS";
export const STAFF_ASSIGNMENT_LOOK_UP = "STAFF_ASSIGNMENT_LOOK_UP";
export const SEARCH_USER_LOOK_UP = "SEARCH_USER_LOOK_UP";
export const UPDATE_STAFF_DATA = "UPDATE_STAFF_DATA";
export const UPDATE_DEFAULT_CLIENTS = "UPDATE_DEFAULT_CLIENTS";